import React from 'react'

import { monthDayYear } from '../../../../../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../../../../../utils/priceTools'
import LinkableTooltip from '../../../../../global/help/Tooltip/LinkableTooltip'
import { OrderPageData } from '../types'
import { ShippingAndPayment } from './../ShippingAndPayment'
import * as Styled from './styled'

export interface OrderDetailsProps {
  className?: string
  order: OrderPageData
}

export const OrderDetails: React.FC<OrderDetailsProps> = ({ className, order }) => {
  return (
    <div className={className}>
      <Styled.OrderDetailsHeader>Order Details</Styled.OrderDetailsHeader>
      <Styled.OrderDetails>
        <Styled.OrderDetail>
          <Styled.OrderDetailType>Order Total: </Styled.OrderDetailType>
          <Styled.OrderTotal>{formatAsCurrencyOrZero({ amount: order.total })}</Styled.OrderTotal>
        </Styled.OrderDetail>
        <Styled.OrderDetail>
          <Styled.OrderDetailType>Date: </Styled.OrderDetailType>
          <Styled.OrderDetailStrong>
            {monthDayYear(order.date, 'EEEE, MMMM do yyyy')} ({monthDayYear(order.date)})
          </Styled.OrderDetailStrong>
        </Styled.OrderDetail>
        <Styled.OrderDetail>
          <Styled.OrderDetailType>Status: </Styled.OrderDetailType>
          <Styled.OrderDetailStrong>{order.status}</Styled.OrderDetailStrong>
        </Styled.OrderDetail>
        {order.__typename === 'CustomerRewardsOrder' && order.orderCustomerName && (
          <Styled.OrderDetail>
            <Styled.OrderDetailType>Name: </Styled.OrderDetailType>
            <Styled.OrderDetailStrong>{order.orderCustomerName}</Styled.OrderDetailStrong>
          </Styled.OrderDetail>
        )}
        {order.__typename === 'CustomerRewardsOrder' && order.orderCustomerEmail && (
          <Styled.OrderDetail>
            <Styled.OrderDetailType>Email: </Styled.OrderDetailType>
            <Styled.OrderDetailStrong>{order.orderCustomerEmail}</Styled.OrderDetailStrong>
          </Styled.OrderDetail>
        )}
        {order.__typename === 'CustomerRewardsOrder' && order.notConsulted != null && (
          <Styled.OrderDetail>
            <Styled.OrderDetailType>Commission: </Styled.OrderDetailType>
            <Styled.OrderDetailStrong>
              {order.notConsulted ? 'Ineligible' : 'Eligible'}
            </Styled.OrderDetailStrong>
            {order.notConsulted && (
              <Styled.OrderHint>
                <LinkableTooltip
                  contents="This patient was referred to you by DFH's Patient Referral program."
                  linkTo="https://www.designsforhealth.com/patient-referral-program"
                />
              </Styled.OrderHint>
            )}
          </Styled.OrderDetail>
        )}
      </Styled.OrderDetails>
      <hr />
      {order.__typename === 'CustomerOrder' && !!(order.shippingAddress || order.payment) && (
        <>
          <ShippingAndPayment order={order} />
          <hr />
        </>
      )}
    </div>
  )
}
